export default "__VITE_ASSET__CFTY9vkl__"